import { render } from "./addComInfo.vue?vue&type=template&id=0d7a3308&scoped=true"
import script from "./addComInfo.vue?vue&type=script&lang=js"
export * from "./addComInfo.vue?vue&type=script&lang=js"

import "./addComInfo.vue?vue&type=style&index=0&id=0d7a3308&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d7a3308"]])

export default __exports__